// vendor
import Vue from 'vue';

const addPoll = (state, payload) => {
  let polls = state.polls.filter((o) => {
    return o.id === payload.id
  });
  let requiredPolls = payload.elements.filter((o) => {
    return o.required === true
  });

  if (polls.length === 0) {
    state.polls.push(payload)
    if (requiredPolls.length !== 0) {
      state.unvalidPolls.push(payload.id)
    }
  }
};

const removePoll = (state, pollId) => {
  state.polls = state.polls.filter((o) => {
    return o.id !== pollId
  });

  state.unvalidPolls = state.unvalidPolls.filter((id) => {
    return id !== pollId
  });
};

const removePolls = (state) => {
  state.polls = [];
};

const setCurrentPoll = (state, payload) => {
  state.currentPoll = payload;
};

const setUserId = (state, userId) => {
  state.userId = userId;
};

const updatePollComponent = (state, component) => {
  state.pollComponent = component;
};

const updatePollErrorState = (state, payload) => {
  Vue.set(state.currentPoll, 'hasError', payload);
};

const setCompanyPollsFetchedState = (state, payload) => {
  state.isFetchedCompanyPolls = payload;
};

const addUnvalidPoll = (state, pollId) => {
  state.unvalidPolls.push(pollId)
};

const removeUnvalidPoll = (state, pollId) => {
  state.unvalidPolls = state.unvalidPolls.filter((id) => {
    return id !== pollId
  });
};
export default {
  addPoll,
  removePoll,
  removePolls,
  setCurrentPoll,
  setUserId,
  updatePollComponent,
  updatePollErrorState,
  setCompanyPollsFetchedState,
  addUnvalidPoll,
  removeUnvalidPoll
}
